<template>
  <div>
    <main-layout>
      <BroadcastMenu />
      <div v-if="currentView === 'list'">
        <v-container>
          <template v-if="loading">
            <div class="text-xs-center" style="padding: 10px 0px">
              <scale-loader
                :color="$vuetify.theme.primary"
                height="35px"
                width="7px"
              ></scale-loader>
            </div>
          </template>
          <div v-else>
            <div
              id="waiting-section"
              style="
                background: #ffffff 0% 0% no-repeat padding-box;
                border-radius: 26px;
                padding: 20px;
              "
            >
              <BroadcastGroup
                title="รอการพิจารณาอนุมัติ"
                status="waiting"
                @viewBroadcast="handleViewBroadcast"
              />
            </div>

            <br />
            <div
              id="approved-section"
              style="
                background: #ffffff 0% 0% no-repeat padding-box;
                border-radius: 26px;
                padding: 20px;
              "
            >
              <BroadcastGroup
                title="บรอดแคสต์ที่พิจารณาแล้ว"
                status="approved"
                @viewBroadcast="handleViewBroadcast"
              />
            </div>
          </div>
        </v-container>
      </div>

      <div v-if="currentView == 'view'">
        <template v-if="selectedViewBroadcast">
          <broadcast-view
            :value="selectedViewBroadcast"
            :is-approver="true"
            @onClose="onClose"
          ></broadcast-view>
        </template>
      </div>
    </main-layout>
  </div>
</template>

<script>
import BroadcastMenu from './BroadcastMenu.vue'
import { mapGetters } from 'vuex'
import BroadcastView from './BroadcastView'
import BroadcastGroup from './BroadcastGroup.vue'

export default {
  components: {
    BroadcastMenu,
    BroadcastView,
    BroadcastGroup
  },
  data() {
    return {
      loading: false,
      selectedViewBroadcast: undefined,
      currentView: 'list'
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },

  methods: {
    handleViewBroadcast(broadcast) {
      const vm = this
      vm.selectedViewBroadcast = broadcast
      vm.$nextTick(function () {
        vm.currentView = 'view'
      })
    },
    onClose() {
      this.currentView = 'list'
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/Aira/Broadcast/ApprovalBroadcast.vue